export const GET_CHAT_DETAILS = "GET_CHAT_DETAILS";
export const RESET_CHAT_DETAILS = "RESET_CHAT_DETAILS";
export const APPEND_NEW_CHAT = "APPEND_NEW_CHAT";
export const GET_SEARCHED_CHAT_DETAILS = "GET_SEARCHED_CHAT_DETAILS";

// LOADING
export const START_LOADING_CHATS = 'START_LOADING_CHATS';
export const STOP_LOADING_CHATS = 'STOP_LOADING_CHATS';